(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-breadcrumbs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const breadcrumbs = document.querySelectorAll('[data-breadcrumb-link]');
    if (!breadcrumbs.length) return;

    breadcrumbs.forEach((breadcrumb) => {
      const productHandle = breadcrumb.dataset.productHandle;
      const storedData = sessionStorage.getItem(`productBreadcrumb:${productHandle}`);
      let breadcrumbData;

      try {
        breadcrumbData = storedData ? JSON.parse(storedData) : null;
      } catch (e) {
        breadcrumbData = null;
      }

      const url = breadcrumbData?.url || breadcrumb.dataset.defaultUrl;
      const title = breadcrumbData?.title || breadcrumb.dataset.defaultTitle;
      const text = breadcrumb.querySelector('[data-breadcrumb-text]');
      breadcrumb.href = url;

      if (text) {
        text.textContent = title;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
